import { defineStore } from "pinia";

export const useModalStore = defineStore("modalStore", {
  state: () => ({
    alertMessage: "",
    confirmMessage: "",
    confirmOptions: null,
    showAlert: false,
    showConfirm: false,
    resolveConfirm: null,
    resolveAlert: null,
    image: null, // 이미지 항목 추가
  }),
  actions: {
    showAlertModal(message) {
      this.alertMessage = message;
      this.showAlert = true;
      return new Promise((resolve) => {
        this.resolveAlert = resolve;
      });
    },
    closeAlert(result) {
      this.showAlert = false;
      if (this.resolveAlert) {
        this.resolveAlert(result);
        this.resolveAlert = null;
      }
    },
    showConfirmModal(message, options = null) {
      this.confirmMessage = message;
      this.confirmOptions = options;
      this.showConfirm = true;

      return new Promise((resolve) => {
        this.resolveConfirm = resolve;
      });
    },
    closeConfirm(result) {
      this.showConfirm = false;
      this.confirmMessage = "";
      this.confirmOptions = null;
      if (this.resolveConfirm) {
        this.resolveConfirm(result);
        this.resolveConfirm = null;
      }
    },
    setImage(image) {
      this.image = image;
    },
    clearImage() {
      this.image = null;
    },
  },
});
